import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/prevalidate/:paymentRequestToken",
    name: "PaymentValidate",
    // route level code-splitting
    // this generates a separate chunk (payment-validate.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webPackChunkName: "PaymentValidate" */ "../views/PaymentValidate.vue"
      ),
  },
  {
    path: "/remit/:paymentRequestToken",
    name: "PaymentRemit",
    id: "paymentRequest",
    // route level code-splitting
    // this generates a separate chunk (payment-remit.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "payment-request" */ "../views/PaymentRemit.vue"
      ),
  },
  {
    path: "/receipt/:paymentRequestToken",
    name: "PaymentReceipt",
    id: "paymentReceipt",
    // route level code-splitting
    // this generates a separate chunk (payment-remit.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "payment-request" */ "../views/PaymentReceipt.vue"
      ),
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
